var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphUpArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 1.5V6C18 6.45 17.7 6.75 17.25 6.75C16.8 6.75 16.5 6.45 16.5 6V3.3L10.65 9.15C10.35 9.45 9.9 9.45 9.6 9.15L6.375 5.925L1.275 11.025C1.125 11.175 0.975 11.25 0.75 11.25C0.525 11.25 0.375 11.175 0.225 11.025C-0.075 10.725 -0.075 10.275 0.225 9.975L5.85 4.35C6.15 4.05 6.6 4.05 6.9 4.35L10.125 7.575L15.45 2.25H12.75C12.3 2.25 12 1.95 12 1.5C12 1.05 12.3 0.75 12.75 0.75H17.25C17.325 0.75 17.475 0.75 17.55 0.825C17.7 0.9 17.85 1.05 17.925 1.2C18 1.275 18 1.425 18 1.5Z",
    fill: "#4CAF50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphUpArrow);
export default __webpack_public_path__ + "static/media/GraphUpArrow.9538fcdc.svg";
export { ForwardRef as ReactComponent };